export const getCurrentProjectId = () => {
    const stored = JSON.parse(localStorage.getItem('currentProject'))?.id || ''
    return stored || ''
}

function isValidDate(d) {
    return d instanceof Date && !isNaN(d)
}

export function fDateTime(date, options) {
    const d = new Date(date)
    if (!isValidDate(d)) {
        return 'Invalid date'
    }

    const defaultOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }

    const formatter = new Intl.DateTimeFormat(
        'en-GB',
        options ?? defaultOptions
    )
    return formatter.format(d)
}

export function fDate(date, options) {
    const d = new Date(date)
    if (isNaN(d.getTime())) {
        return 'Invalid date'
    }

    const defaultOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }

    const formatter = new Intl.DateTimeFormat(
        'en-GB',
        options ?? defaultOptions
    )
    return formatter.format(d)
}

export const isValidArray = (data) =>
    data && Array.isArray(data) && data.length > 0

export const isValidObject = (data) =>
    typeof data === 'object' && data !== null && Object.keys(data).length !== 0

export const createSelectOptions = (option) => {
    if (option) {
        return {
            label: option || '',
            value: option || '',
        }
    }
    return ''
}
